import { Image } from '@lt/components';
import { Star } from '@lt/components/icons-react/userflow';
import { useTranslation } from '@lt/localization';
import React from 'react';
import styled from 'styled-components';

import type { HotelSummaryInfo } from '../../../../types';
import {
  TEST_ID_MOBILE_SUMMARY_HOTEL_INFO_BTN,
  TEST_ID_MOBILE_SUMMARY_HOTEL_INFO_NAME,
} from './constants';

type Props = {
  hotel: HotelSummaryInfo;
  onClick: () => void;
};

const HotelInfo = (props: Props) => {
  const { hotel, onClick } = props;

  const { t } = useTranslation();
  return (
    <Wrapper>
      <TextContainer>
        <Name data-testid={TEST_ID_MOBILE_SUMMARY_HOTEL_INFO_NAME}>
          {hotel.name}, {hotel.stars}
          <HotelStar />
        </Name>
        <Location>{hotel.location}</Location>
        <div>
          <OpenHotelInfoBtn
            data-testid={TEST_ID_MOBILE_SUMMARY_HOTEL_INFO_BTN}
            onClick={onClick}
          >
            {t('checkout.packageInfo.room.aboutButton')}
          </OpenHotelInfoBtn>
          <Meal> · {hotel.meal}</Meal>
        </div>
      </TextContainer>
      <ImageContainer>
        <HotelImage fallback="Фото отеля" src={hotel.image} />
      </ImageContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
`;

const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

const HotelStar = styled(Star)`
  width: 14px;
  height: 14px;
  fill: #ffd600;

  margin-left: 2px;
`;

const TextContainer = styled.div`
  flex: 1;
`;

const Name = styled.div``;

const Location = styled.div`
  color: #4d4d4d;
  margin-bottom: 8px;
`;

const OpenHotelInfoBtn = styled.span`
  color: #007aff;
  cursor: pointer;

  &:active {
    color: #179fe3;
  }
`;

const Meal = styled.span`
  color: #919499;
`;

const HotelImage = styled(Image)`
  width: 32px;
  height: 32px;
  border-radius: 4px;
`;

export default HotelInfo;
